module.exports = __webpack_public_path__ + "media/tags/smartsearch/search-icon-7d737b6f6d1f1368c0e1625d87ab4957.png";